export default __webpack_public_path__ + "static/media/cryptofont-webfont.031f1a21.svg";